<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content comment-entry" v-if="currentCommentIssue && (currentCommentIssue.point || (currentCommentIssue.id && !currentCommentIssue.delete))">
    <div slot="header">
      <label>{{currentCommentIssue && currentCommentIssue.id ? 'Edit Comment' : 'New Comment'}}</label>
      <!-- <window-header :cmp-title="currentCommentIssue && currentCommentIssue.id ? 'Edit Comment' : 'New Comment'" widget-name="comments"></window-header> -->
    </div>

    <div :style="{'flex': 3, 'overflow': 'auto'}">
      <div class="p-2">
        <b-form>
          <b-form-group
            label="Subject">
            <b-form-input type='text' v-model="subject"></b-form-input>
          </b-form-group>

          <b-form-group
            label="Description">
            <b-form-textarea :rows="2" v-model="description"></b-form-textarea>
          </b-form-group>

          <b-form-group
            label="Status">
            <b-form-select v-model="status" :options="issueStatuses"></b-form-select>
          </b-form-group>
          <b-form-group
            label="Assignee">
            <b-form-select id='assignee-select' type='text' v-model='assignee' :options="users"></b-form-select>
          </b-form-group>
        </b-form>
        <div class='note-container' v-if='currentCommentIssue && currentCommentIssue.id'>
          <div class='note-container-header'>
            <legend class='legend'>
              Notes
            </legend>
            <b-button v-if='!newNote' @click='startNewNote'>New Note</b-button>
            <b-button v-if='newNote' @click='saveNote'>Save Note</b-button>
            <b-button v-if='newNote' @click='newNote = !newNote'>Cancel</b-button>
          </div>
          <b-form v-if='newNote'>
            <b-form-group
              label="New Note">
              <b-form-textarea :rows="2" v-model="currentNote"></b-form-textarea>
            </b-form-group>
          </b-form>
          <div class='note-container-body'>
            <ul class='note-list'>
              <li>
                <div class='note-item' v-for='(n, i) in notes'>
                  <div class='note-header'>
                    <span class='note-update-boiler'>Updated by</span>
                    <span class='note-user'>{{n.user.name}}</span>
                    <span class='note-date'>on {{new Date(n.created_on).toLocaleString()}}</span>
                  </div>
                  <div class='note-body'>
                    <span class='note-text' v-if='!editNote || !editState(n.id)'>
                      {{n.notes}}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-between p-1 pr-4">
      <b-btn class="float-left btn btn-xs" @click="hideModal">
        Cancel
      </b-btn>
      <b-btn :disabled="saving" class="float-right btn-xs" @click="saveCurrentCommentIssue">
        Save
      </b-btn>
    </div>
  </b-card>

</template>
<script>
  import 'vue-awesome/icons/comment'
  import 'vue-awesome/icons/save'
  import 'vue-awesome/icons/sticky-note'
  import store from '../../store'
  import waterfall from 'async/waterfall'
  import timesAsync from 'async/times'
  import parallelAsync from 'async/parallel'
  import Feature from 'ol/Feature'
  import Point from 'ol/geom/Point'
  import VectorLayer from 'ol/layer/Vector'
  import VectorSource from 'ol/source/Vector'
  import Style from 'ol/style/Style'
  import StyleFill from 'ol/style/Fill'
  import StyleStroke from 'ol/style/Stroke'
  import CircleStyle from 'ol/style/Circle'
  import RegularShape from 'ol/style/RegularShape'
  import Overlay from 'ol/Overlay'
  import { hex2rgba } from '../../util/misc'
  import WktFormat from 'ol/format/WKT'
  import Vue from 'vue'
  import Popup from './Popup'
  import WindowHeader from '../common/WindowHeader'
  import Draw from 'ol/interaction/Draw'


  export default {
    name: 'comments',
    components: {WindowHeader},
    data () {
      return {
        project: null,
        subject: '',
        description: '',
        saving: false,
        loading: false,
        status: 0,
        issueStatuses: [],
        commentTrackerId: null,
        users: [],
        assignee: '',
        currentNote: '',
        newNote: false,
        notes: [],
        editNote: false,
        memberProjectId: null
      }
    },
    created () {
      this.overlayes = []
      this.commentTracker = null
      this.geoCf = null
      /*document.body.addEventListener('mouseup', (e) => {
        this.onMapClick(e)
      })*/
    },
    computed: {
      enabled () {
        return this.$store.getters['cmp/all']['comments']['enabled']
      },
      commentState: {
        get () {
          return this.$store.getters['map/commentState']
        },
        set (val) {
          this.$store.commit('map/commentState', val)
        }
      },
      user () {
        return store.getters['user/user']
      },
      currentProject: () => store.getters['project/currentProject'],
      olInitialised: () => store.getters['map/initialised'],
      currentCommentIssue: {
        get () {
          return store.getters['map/currentCommentIssue']
        },
        set (val) {
          store.commit('currentCommentIssue', val)
        }
      }
    },
    mounted () {
      this.createCommentsLayer()
      this.loadProject()
      let layer = this.$mapService.map.getLayers().getArray().filter(layer => layer.get('kegs_id') === 'comments_custom_v5')[0]
      this.loadProjectMembers(this.currentProject.id, layer, true)
    },
    watch: {
      enabled (val) {
        let layer = this.$mapService.map.getLayers().getArray().filter(layer => layer.get('kegs_id') === 'comments_custom_v5')[0]
        if (layer) {
          layer.setVisible(val)
          if (!val) {
            this.hideOverlays()
          } else {
            this.showOverlays()
          }
        }
      },
      commentState (val) {
        if (val) {
          // document.body.style.cursor = 'crosshair'
          // this.$mapService.addListener('singleclick', this.onMapClick, this)
          this.draw.once('drawend', this.onMapClick)
          this.$mapService.addInteraction(this.draw)
        } else {
          // document.body.style.cursor = 'default'
          // this.$mapService.removeListener('singleclick', this.onMapClick, this)
          this.$mapService.removeInteraction(this.draw)
        }

      },
      currentCommentIssue (val) {
        var me = this
        if (val && val.delete) {
          this.deleteIssue(val)
          return
        }

        if (val && val.view) {
          window.open([location.protocol + '/', location.host, 'mine', 'issues', val.id].join('/'))
          return
        }
        if (val) {
          if (val.id) {
            this.$http.get('/api/redmine/issues/'+ val.id +'.json?include=journals')
              .then(res => {
                  if (res.body.issue && res.body.issue.journals) {
                    let x = res.body.issue.journals.filter(j => {
                      return j.notes
                    })
                    me.notes = x
                  }
              }, res => {
                console.log('Error thrown on issue journal request')
              })
          }
          this.subject = val.subject || ''
          this.description = val.description || ''
          if (val.assigned_to) {
            let x = this.loadCommentUser(val.assigned_to.id)
            this.assignee = x[0].value
          } else {
            this.assignee = ''
          }
          this.status = val.status ? val.status.id : undefined
        }
      },
      currentProject (val) {
        this.loadProject()
      },
      olInitialised (val) {
        if (val) {
          this.createCommentsLayer()
        }
      }
    },
    methods: {
      loadProject () {
        this.loading = true
        parallelAsync([
          (clb) => {
            if (!this.geoCf) {
              this.$http.get('/api/redmine/custom_fields.json')
                .then(res => {
                  this.geoCf = res.body.custom_fields.filter(f => f.name.toLowerCase() === 'geo')[0]
                  clb(null)
                }, res => {
                  clb('err')
                })
            }
          },
          (clb) => {
            if (this.issueStatuses.length >= 0 && !this.geoCf) {
              this.$http.get('/api/redmine/trackers.json')
                .then(res => {
                  this.commentTrackerId = res.body.trackers.find(t => t.name === "Comment").id
                  this.$http.get('/api/projects/get-workflows/?tracker_ids='+this.commentTrackerId)
                    .then(res => {

                      res = res.body.filter((w, index, self) =>
                        index === self.findIndex((t) => (
                          t.new_status_name === w.new_status_name
                        ))
                      )
                      this.issueStatuses = res.map(w => {
                        return {
                          value: w.new_status_id,
                          text: w.new_status_name
                        }
                      })
                      clb(null)
                    }, res => {
                      this.issueStatuses = [{
                        value: 1,
                        text: 'New'
                      }]
                      clb(null)
                    })

                }, res => {
                  clb('err')
                })
            }
          },
          (clb) => {
            this.$http.get(`/api/redmine/projects/${this.currentProject.id}.json`, {
              params: {
                include: 'trackers'
              }
            })
              .then(res => {
                this.project = res.body.project
                clb(null)
              }, res => {
                clb('err')
              })
          }
        ], (err, res) => {
          this.loading = false
          if (!err) {
            this.loadComments()
          } else {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load comments project',
              type: 'error'
            })
          }
        })
      },
      loadProjectMembers (projectId, layer, val) {
        this.$http.get(`/api/redmine/projects/${projectId}/memberships.json`)
          .then(res => {
            res = res.body.memberships.filter(m => {return m.user})
            this.users = res.map(m => {
              return {
                text: m.user.name,
                value: m.user.id
              }
            })
            layer.setVisible(val)
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load project members',
              type: 'error'
            })
          })
      },
      editState (id) {
        return id === this.editNote
      },
      startNewNote () {
        this.currentNote = ''
        this.newNote = !this.newNote
      },
      saveNote () {
        this.newNote = !this.newNote
        let name = this.user.username.split('.')[0] + ' ' + this.user.username.split('.')[1]
        let id = this.notes.length ? this.notes[this.notes.length - 1].id + 1 : 1
        let n = {
          'issue': {
            'notes': this.currentNote
          }
        }
        var me = this
        this.$http.put('/api/redmine/issues/'+ this.currentCommentIssue.id +'.json', n)
          .then(res => {
              console.log('test save note response')
              console.log(res)
              this.$http.get('/api/redmine/issues/'+ me.currentCommentIssue.id +'.json?include=journals')
                .then(res => {
                    if (res.body.issue && res.body.issue.journals) {
                      let x = res.body.issue.journals.filter(j => {
                        return j.notes
                      })
                      me.notes = x
                    }
                }, res => {
                  console.log('Error thrown on issue journal request')
                })
          }, res => {
            console.log('Error thrown on issue journal request')
          })
      },
      loadCommentUser (id) {
        return this.users.filter(u => {return u.value === id })
      },
      loadComments () {
        let tracker = this.project.trackers.filter(t => t.name.toLowerCase().indexOf('comment') > -1)[0]
        if (!tracker) {
          console.log('THIS PROJECT DOES NOT HAVE COMMENTS TRACKER')
          return
        }
        this.loading = true
        this.commentTracker = tracker
        let issues = []
        waterfall([
          (clb) => {
            let step = 100
            this.$http.get(`/api/redmine/issues.json?project_id=${this.currentProject.id}&tracker_id=${tracker.id}&limit=${step}&status_id=open`)
              .then(res => {
                issues = issues.concat(res.body.issues)
                let totalCount = res.body.total_count
                let remainder = totalCount - step
                let nSteps = remainder > 0 ? Math.ceil(remainder / step) : 0
                clb(null, nSteps, step)
              }, res => {
                clb('could not load issues')
              })
          },
          (nSteps, step, clb) => {
            timesAsync(nSteps, (n, next) => {
              this.$http.get(`/api/redmine/issues.json?project_id=${this.currentProject.id}&tracker_id=${tracker.id}&offset=${step * (n + 1)}&limit=${step}`)
                .then(res => {
                  issues = issues.concat(res.body.issues)
                  next(null)
                }, res => {
                  next('could not load issues step')
                })
            }, clb)
          }
        ], (err, res) => {
          this.loading = false
          if (err) {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load comments',
              type: 'error'
            })
            return
          }
          this.renderComments(issues)
        })
      },
      createCommentsLayer () {
        console.log('Creating comments layer')
        let exists = this.$mapService.map.getLayers().getArray().filter(layer => layer.get('kegs_id') === 'comments_custom_v5')[0]
        if (exists) {
          console.log('layer already initialised')
          return
        }

        let layer = new VectorLayer({
          visible: true,
          zIndex: 10000000,
          source: new VectorSource({
            features: []
          }),
          style: new Style({
            image: new RegularShape({
              radius: 10,
              angle: 0,
              points: 4,
              stroke: new StyleStroke({
                color: hex2rgba('#000000', 1),
                width: 1
              }),
              fill: new StyleFill({
                color: hex2rgba('#008000', 1)
              })
            })
          })
        })
        layer.set('kegs_id', 'comments_custom_v5')
        this.$mapService.map.addLayer(layer)

        this.draw = new Draw({
          source: layer.getSource(),
          type: 'Point',
        });
      },
      renderComments (issues) {
        console.log(`rendering ${issues.length} comments`)
        store.commit('map/commentIssues', issues)
        let layer = this.$mapService.map.getLayers().getArray().filter(layer => layer.get('kegs_id') === 'comments_custom_v5')[0]
        if (layer) {
          layer.getSource().clear()
          let features = this.issues2feature(issues)
          console.log(`having ${features.length} comments`)
          let wkt = new WktFormat()
          features.forEach(f => {
            console.log(wkt.writeFeatureText(f))
          })

          layer.getSource().addFeatures(features)
//          this.$mapService.map.getView().fit(layer.getSource().getExtent(), {
//            padding: [10, 10, 10, 10]
//          })
          Vue.nextTick(() => {
            this.clearOverlays()
            this.addOverLays(features)
          })
        } else {
          console.error('comment layer not found')
        }

//        setTimeout(() => {
//          console.log('reloading comments')
//          this.loadComments()
//        }, 10000)
      },
      issues2feature (issues) {
        let wkt = new WktFormat()
        return issues.filter(issue => {
          if (issue.custom_fields) {
            return issue.custom_fields.filter(cf => cf.name === 'geo' && cf.value).length
          }
          return false
        }).map(issue => {
          let cfGeo = issue.custom_fields.filter(cf => cf.name === 'geo')[0]
          let geometry
          try {
            geometry = wkt.readGeometry(cfGeo.value)
          } catch (e) {
            console.error('parse geo field ' + cfGeo.value)
            return false
          }
          let feature = new Feature()
          feature.set('issue', issue)
          // geometry = geometry.transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))
          feature.setGeometry(geometry)
          return feature
        }).filter(f => f)
      },
      hideOverlays() {
        this.overlayes.forEach(o => o.overlay.setPosition(undefined))
      },
      showOverlays() {
        this.overlayes.forEach(o => o.overlay.setPosition(o.position))
      },
      clearOverlays () {
        this.overlayes.forEach(o => o.cmp.$destroy())

        this.$mapService.map.getOverlays().getArray().forEach(o => {
          /*if (this.commentIssues && this.commentIssues.map(i => i.id).indexOf(o.getId()) === -1) {

          }*/
          this.$mapService.map.removeOverlay(o)
        })
        this.overlayes = []
      },
      addOverLays (features) {
        features.forEach(feature => {
          if (this.overlayes.map(o => o.issue.id).indexOf(feature.get('issue').id) > -1) {
            return
          }
//          console.log(document.getElementById('comment-' + feature.get('issue').id))

          let ComponentClass = Vue.extend(Popup)
          let instance = new ComponentClass({
            propsData: {
              issue: feature.get('issue')
            }
          })
          instance.$mount()

          let overlay = new Overlay({
            id: feature.get('issue').id,
            element: instance.$el,
            autoPan: true,
            autoPanAnimation: {
              duration: 250
            }
          })

          this.overlayes.push({
            overlay: overlay,
            issue: feature.get('issue'),
            cmp: instance,
            position: feature.getGeometry().getCoordinates()
          })

          overlay.setPosition(feature.getGeometry().getCoordinates())
          this.$mapService.map.addOverlay(overlay)
        })

      },
      saveCurrentCommentIssue () {
        if (!this.commentTracker) {
          this.$notify({
            title: 'ERROR',
            text: 'Cannot save because Comments tracker not available',
            type: 'error'
          })
          return
        }

        if (!this.geoCf) {
          this.$notify({
            title: 'ERROR',
            text: 'Cannot save because custom field geo is not available',
            type: 'error'
          })
          return
        }

        let payload = {
          tracker_id: this.commentTracker.id,
          project_id: this.currentProject.id,
          status_id: this.status,
          priority_id: 2,
          subject: this.subject,
          description: this.description,
          assigned_to_id : this.assignee
        }

        let save = this.currentCommentIssue.id ? this.$http.put : this.$http.post
        let url = this.currentCommentIssue.id ? `/api/redmine/issues/${this.currentCommentIssue.id}.json` : '/api/redmine/issues.json'

        if (this.currentCommentIssue.point) {
          let wkt = new WktFormat()
          payload['custom_fields'] = [
            {
              id: this.geoCf.id,
              value: `POINT(${this.currentCommentIssue.point.join(' ')})`
            }
          ]
        }

        this.saving = true
        save.call(this.$http, url, {
          issue: payload
        }).then(res => {
          this.$notify({
            title: 'SUCCESS',
            text: 'Comment successfully saved',
            type: 'success'
          })
          store.commit('map/currentCommentIssue', null)
          this.saving = false
          this.loadComments()
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not save comment',
            type: 'error'
          })
          this.saving = false
        })
      },
      hideModal () {
        store.commit('map/currentCommentIssue', null)
      },
      onModalHidden () {
        store.commit('map/currentCommentIssue', null)
      },
      onMouseDown (e) {
        this.commentState = true
      },
      onMapClick (e) {

        if (this.commentState) {
          this.commentState = false

          let coord = e.feature.getGeometry().getCoordinates()
          console.log(coord)
          store.commit('map/currentCommentIssue', {
            point: coord
          })
        }
      },
      deleteIssue (issue) {
        if (confirm('Please, confirm deleting comment')) {
          this.$http.delete(`/api/redmine/issues/${issue.id}.json`)
            .then(res => {
              this.$notify({
                title: 'SUCCESS',
                text: 'Comment successfully removed',
                type: 'success'
              })
              this.loadComments()
            }, res => {
              this.$notify({
                title: 'ERROR',
                text: 'Could not remove comment',
                type: 'error'
              })
            })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/CommentTool.vue